import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { BiReport } from '@app/core/model/entities/bi-report/bi-report';
import { AccessManager } from '@services/managers/access.manager';

@Component({
  templateUrl: './user-bi-reports.component.html',
  standalone: false
})
export class UserBiReportsComponent implements OnInit {

  protected globalBIReport: FormControl<BiReport>;
  protected EntityType = EntityTypeEnum;
  protected workspaceId: string;

  private route = inject(ActivatedRoute);
  private accessManager = inject(AccessManager);
  private destroyRef = inject(DestroyRef);

  /**
   * Set the global Power BI report according to its name (variable passed in url parameter).
   */
  public ngOnInit(): void {
    this.workspaceId = this.accessManager.currentUser.workspaceId;
    this.accessManager.userBiReports$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(userBiReports => {
      this.globalBIReport = new FormControl(
        userBiReports.find(userBiReport => userBiReport.id === this.route.snapshot.paramMap.get('id'))
      );
    });
  }
}
